import { useContext } from "react";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";
import CircuitBreakerSVG from "./CircuitBreakerSVG";
import  embLabels from "../../../config/emb-labels-en.json";

const  LinebarSLD = () => {
     const {
   switchboardType,
   loadSide,
   count,
  } = useContext(DesignAssetContext);
    return (
        <svg x={switchboardType === embLabels?.EXISTING_SWITCHBOARD ? -31 : 0} y={switchboardType === embLabels?.EXISTING_SWITCHBOARD ? -15: 0} >
           <g>
         { loadSide === "LOAD_SIDE" &&  <line
                x1="335.1" y1="285" x2="335.1" y2="340"
                stroke="var(--se-sld-circline)"
                strokeWidth="3"
            />}
             <line
                x1={
                    loadSide === "LOAD_SIDE"
                        ? "335"
                        : "235.1"
                }
                y1={
                    loadSide === "LOAD_SIDE" ? "340"
                        : "212"
                }
                x2="605"
                y2={
                    loadSide === "LOAD_SIDE" ? "340"
                        : "212"
                }
                stroke="var(--se-sld-circline)"
                strokeWidth="3"

            />
            <line
                x1="605"
                y1={loadSide === "LOAD_SIDE" ? "385" : "211"}
                x2="605"
                y2={
                    loadSide === "LOAD_SIDE"
                        ? "339"
                        : "382.5"
                }
                stroke="var(--se-sld-circline)"
                strokeWidth="3"
            />
           </g>
           <CircuitBreakerSVG
            id={"_Utility_Line"}
            x={570}
            y={385}
            index={0}
            cbRequiredSelection={true}
            isEVCb={false}
        />
        </svg>
        
    );
};

export default LinebarSLD;